import { useEffect } from 'react'

import { rg4js } from '@/utils/raygun'

import { User } from '@/types'

export function useRaygun(user: User | undefined) {
  useEffect(() => {
    if (user?.id && user?.email) {
      rg4js('setUser', {
        identifier: user.id,
        email: user.email,
        uuid: user.id,
        isAnonymous: false,
      })
    }
  }, [user?.id, user?.email])
}
